import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  // Header Section
  headerContainer: {
    marginBottom: '2rem',
  },
  headerTitle: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  headerDescription: {
    margin: 0,
    color: '#666',
  },

  // Form Section
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  // Dataset Name Input and Action Buttons
  nameAndButtonsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    flexShrink: 0,
  },
  nameFieldContainer: {
    maxWidth: '200px',
  },
  nameFieldError: {
    color: 'red',
    marginTop: '0.25rem',
  },
  buttonsContainer: {
    display: 'flex',
    gap: '0',
    paddingTop: '22px',
    paddingLeft: '50px',
  },

  // Images Selection
  imagesSelectionContainer: {
    padding: '0.5rem',
  },

  // Error Messages
  errorMessage: {
    color: 'red',
    flexShrink: 0,
  },
})

export default useStyles
